import { render, staticRenderFns } from "./ChartCanvasSb.vue?vue&type=template&id=a6f8a210&scoped=true"
import script from "./ChartCanvasSb.vue?vue&type=script&lang=js"
export * from "./ChartCanvasSb.vue?vue&type=script&lang=js"
import style0 from "./ChartCanvasSb.vue?vue&type=style&index=0&id=a6f8a210&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6f8a210",
  null
  
)

export default component.exports